import React from 'react';
import CardFeature from './CardFeature';

const CardFeatures = ({ features, currentIndex, onStartGeometryEdit, onCloseModal }) => {
  const currentFeature = features[currentIndex];
  return (
    <CardFeature 
      feature={currentFeature} 
      onStartGeometryEdit={onStartGeometryEdit}
      onCloseModal={onCloseModal}
    />
  );
};

export default CardFeatures;
